import React, {useRef} from 'react'
import {Hero} from '../components'
import {useParams} from 'react-router-dom'
import {attractions} from '../utils/attractions'
import ErrorScreen from './ErrorScreen'
import {Link} from 'react-router-dom'
import {IoIosArrowDropleftCircle} from 'react-icons/io'
import {MapContainer, TileLayer, Marker, Popup} from 'react-leaflet'
import {locals} from '../utils/map'
import useTitle from '../custom/useTitle'
import useDescription from '../custom/useDescription'

const scrollToRef = () => window.scrollTo(0,0)   
    
function SingleAttraction() {
    const {id} = useParams();
    const myRef = useRef(null);
    const executeScroll = () => scrollToRef()
    const single = attractions.filter(el=>el.title === id)[0];
    useTitle(single.title)
    useDescription(single.text)
    return (
        <div ref={myRef}>
        {
            single === undefined ? 
            <ErrorScreen/>:
            <div>
                <Hero overlay>
                    <hr/>
                        <div>
                            <h3>Attrazioni di Ceppo</h3>
                        </div>
                    <hr/>
                </Hero>
                <div className="section-text">
                    <div>
                        <Link to="/attrazioni" className="return-button title" onClick={executeScroll}>
                            <IoIosArrowDropleftCircle/>
                            torna indietro
                        </Link>
                        </div>
                    <section className="attraction-grid">
                        <img src={single.img} alt={single.title} className="single-img"/>
                        <div className="single-text">
                            <header>
                                <h4 style={{textAlign:"center"}}>{single.title}</h4>
                                <hr style={{width:"90%", margin:"auto"}}/>
                            </header>
                            <p style={{marginTop:"10px",marginBottom:"10px"}}>{single.text}</p>
                            <div className="tag-section">
                                {
                                    single.tags.map(el=>{
                                        return <span key={el} className="attraction-color">{el}</span>
                                    })
                                }
                            </div>
                        </div>
                    </section>
                </div>
                <div className="section-text">
                    <h2 style={{textAlign:"center", margin:"10px"}}>Posizione sulla Mappa</h2>
                    <hr/>
                    <div className="map-container">
                        <MapContainer center={single.coords} zoom={13} scrollWheelZoom={true} className="map">
                            <TileLayer 
                                attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors | <a href="/mappa">vedi mappa completa</a>'
                                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"/>
                            <Marker position={single.coords}>
                                <Popup >
                                    <img src={single.icon} alt={single.title} className="popup-image"/>
                                    <div className="popup-text">{single.title}</div>
                                </Popup>
                            </Marker>
                            <Marker position={locals.ceppo}>
                                <Popup>
                                    Ceppo - Piazzale
                                </Popup>
                            </Marker>
                        </MapContainer>
                    </div>        
                </div>
            </div>
        }
        </div>
    )
}

export default SingleAttraction
